const MAKE_OFFERS_CHECK_BOX = "makeOffersCheckBox";
const CHECK_BOX_CHECKED = "checkboxChecked";
const THIRD_PARTIES_CHECK_BOX = "thirdPartiesCheckBox";

export { MAKE_OFFERS_CHECK_BOX, CHECK_BOX_CHECKED, THIRD_PARTIES_CHECK_BOX };